module.exports = __webpack_public_path__ + "static/media/partner-logo13.9b8dc86f.png";